import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

/**
 * Gemeinsamer Tabellen-Container: horizontales Scrollen statt Spalten-Quetschen
 * am Phone (Muster: logbook.tsx). Rahmen/Radius zentral, per className
 * überschreibbar (twMerge) — z.B. `rounded-2xl` für Karten-Tabellen.
 */
export function TableShell({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('overflow-x-auto rounded-xl border border-border-subtle', className)}
      {...props}
    >
      {children}
    </div>
  )
}
